'use client';
import { Box } from '@mui/material';

import { LogosCarouselType } from './type';
import DarkThemeProvider from '../../../providers/DarkThemeProvider';
import LightThemeProvider from '../../../providers/LightThemeProvider';
import LogoItem from './LogoItem';

type Props = {
  data: LogosCarouselType;
};

const LogosCarouselComponent = ({ data }: Props) => {
  const { logos, grayscale, pauseOnHover, stopped, width, styling } = data;
  const ThemeProvider = styling.isDark ? DarkThemeProvider : LightThemeProvider;

  const track = stopped === 'both' ? logos : [...logos, ...logos];
  const speed = Math.max(30, logos.length * 8);
  const anim = `logosScroll ${speed}s linear infinite`;

  const trackSx =
    stopped === 'both'
      ? { flexWrap: 'wrap', justifyContent: 'center' }
      : {
          width: 'max-content',
          animation:
            stopped === 'mobile'
              ? { xs: 'none', md: anim }
              : stopped === 'desktop'
                ? { xs: anim, md: 'none' }
                : anim,
          '@keyframes logosScroll': {
            '0%': { transform: 'translateX(0)' },
            '100%': { transform: 'translateX(-50%)' },
          },
          ...(pauseOnHover && {
            '&:hover': { animationPlayState: 'paused' },
          }),
        };

  return (
    <ThemeProvider>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            maxWidth: width,
            overflow: 'hidden',
            position: 'relative',
            width: '100%',
            py: { xs: 3, md: 4 },
            ...styling.sx,
          }}
        >
          <Box
            className={'tb-logo-carousel-image-row'}
            sx={{ display: 'flex', ...trackSx }}
          >
            {track.map((logo, idx) => (
              <LogoItem
                key={`${logo.id}_${idx}`}
                logo={logo}
                pauseOnHover={pauseOnHover}
                grayscale={grayscale}
                logoSize={styling.logoSize}
              />
            ))}
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default LogosCarouselComponent;
